import "./scrollTriggerAni.scss";


import { isMobile, select } from "../Helper";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let mmmd = gsap.matchMedia();

function simpleParalax() {
    const agse = document.querySelector(".agenda-section");

    if (!isMobile() && agse) {
        const cards = document.querySelectorAll(".wc-box");
        cards.forEach((card, index) => {
            gsap.to(card, {
                yPercent: (index + 1) * 20,
                ease: "none",
                scrollTrigger: {
                    trigger: card,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                },
            });
        });
    }
}

function cardOverlap() {
   
    const details = gsap.utils.toArray(
        ".desktopContentSection:not(:first-child)"
    );
    const photos = gsap.utils.toArray(".desktopPhoto:not(:first-child)");

    gsap.set(photos, { yPercent: 101 });

    const allPhotos = gsap.utils.toArray(".desktopPhoto");

    ScrollTrigger.create({
        trigger: ".gallery",
        start: "top top",
        end: "bottom bottom",
        pin: ".right",
    });

    //create scrolltrigger for each details section
    //trigger photo animation when headline of each details section
    //reaches 80% of window height
    details.forEach((detail, index) => {
        let headline = detail.querySelector("h1");
        let animation = gsap
            .timeline()
            .to(photos[index], { yPercent: 0 })
            .set(allPhotos[index], { autoAlpha: 0 });
        ScrollTrigger.create({
            trigger: headline,
            start: "top 80%",
            end: "top 50%",
            animation: animation,
            scrub: true,
            markers: false,
        });
    });
}

function pillShapeTransform() {
    const pillHeader = document.querySelector(".pil-header");
    const pillContainer = document.querySelector(".pill-container");
    const pillWaves = document.querySelectorAll(".pill-shape-wave");
    const h2 = document.querySelector(".pil-header h2");
    const p = document.querySelector(".pil-header p");

    if (!pillHeader || !pillContainer) return;

    gsap.set(p, { autoAlpha: 0 });

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: pillHeader,
            start: "top top",
            end: "+=2500",
            scrub: 1,
            pin: true,
            anticipatePin: 1,
        },
    });

    tl.to(pillContainer, {
        borderRadius: "999px",
        scale: 0.7,
        ease: "power2.inOut",
    }, 0)
    .to(h2, {
        autoAlpha: 0,
        ease: "power2.in",
    }, 0.4)
    .to(pillContainer, {
        "--blur-opacity": 1,
        ease: "power2.inOut",
    }, 0.55)
    .to(p, {
        autoAlpha: 1,
        ease: "power2.out",
    }, 0.7)
    .to(pillContainer, {
        "--wave-opacity": 1,
        ease: "power2.out",
        duration: 0.5,
    }, 0.9)
    .to(pillWaves, {
        opacity: 1,
        ease: "power2.out",
    }, 0.9);
}


/**
 * Text Reveal Animation
 * Animates text from opacity 0.2 to 1 based on scroll.
 */
function initTextReveal() {
    // 1. Select ALL elements with the class
    const revealSections = document.querySelectorAll(".text-reveal");
    
    revealSections.forEach((section) => {
        const trHeading = section.querySelector("h2");
        const trParagraph = section.querySelector("p");

        // 1. Split Heading into Characters
        if (trHeading && !trHeading.querySelector('.char')) {
            const content = trHeading.textContent;
            trHeading.innerHTML = content
                .split("")
                .map((char) => `<span class="char" style="opacity: 0.2; display: inline-block;">${char === " " ? "&nbsp;" : char}</span>`)
                .join("");
        }

        // 2. Split Paragraph into Words
        if (trParagraph && !trParagraph.querySelector('.word')) {
            const words = trParagraph.textContent.trim().split(/\s+/);
            trParagraph.innerHTML = words
                .map((word) => `<span class="word" style="opacity: 0.2; display: inline-block; margin-right: 0.2em;">${word}</span>`)
                .join("");
        }

        // 3. Create a unique timeline for THIS specific section
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section, // Trigger is the current section in the loop
                start: "top 80%",
                end: "top 20%",
                scrub: true,
                markers: false,
            }
        });

        if (trHeading) {
            const chars = trHeading.querySelectorAll('.char');
            tl.to(chars, {
                opacity: 1,
                stagger: 0.1,
                ease: "none"
            });
        }

        if (trParagraph) {
            const words = trParagraph.querySelectorAll('.word');
            tl.to(words, {
                opacity: 1,
                stagger: 0.1,
                ease: "none"
            }, "+=0.1");
        }
    });
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Initializes the GSAP Map Scroll Animation
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
const initMapSlider = () => {
    gsap.registerPlugin(ScrollTrigger);

    const slider = document.getElementById('mapSlider');
    const radiusCircle = document.querySelector('.radius-circle');
    const navItems = document.querySelectorAll('.nav-item');
    const landmarkGroups = document.querySelectorAll('.landmark-group');
    const mm = gsap.matchMedia();

    if (!slider || !radiusCircle) return;

    let lastActiveIndex = -1;

    mm.add({
        isDesktop: "(min-width: 1091px)",
        isTablet: "(min-width: 768px) and (max-width: 1090px)",
        isMobile: "(max-width: 767px)"
    }, (context) => {
        let { isDesktop, isTablet, isMobile } = context.conditions;

        // 1. PINNING: Only enable on Desktop to prevent white space on others
        const shouldPin = isDesktop;

        // 2. SEPARATED START: Desktop (120px), Tablet (70%), Mobile (90%)
        const startPos = isDesktop ? "top 120px" : (isTablet ? "top 70%" : "top 67%");

        // 3. DISTANCE: Shorter distances for touch devices so the animation finishes quickly
        const scrollDistance = isDesktop ? "+=3650" : (isTablet ? "+=750" : "+=550");

        // 4. CIRCLE SCALE: Adjusted for screen widths
        const endSize = isDesktop ? 580 : (isTablet ? 250 : 280);
        // 5. Complete animation a bit early, then hold pinned at the end.
        const completionPoint = shouldPin ? 0.9 : 1;

        const tl = gsap.timeline({ 
            scrollTrigger: {
                trigger: ".map-scroll-section",
                start: startPos,
                end: scrollDistance,
                pin: shouldPin, 
                pinSpacing: shouldPin, 
                scrub: 0.5,
                invalidateOnRefresh: true, 
                onUpdate: (self) => {
                    const rawProgress = self.progress;
                    const progress = Math.min(rawProgress / completionPoint, 1);
                    slider.value = progress * 100;
                    slider.style.setProperty('--scroll-percent', (progress * 100) + '%');

                    const activeIndex = Math.round(progress * (navItems.length - 1));
                    navItems.forEach((item, index) => {
                        item.classList.toggle('active', index === activeIndex);
                    });

                    if (activeIndex !== lastActiveIndex) {
                        lastActiveIndex = activeIndex;

                        landmarkGroups.forEach((group) => {
                            const isActive = parseInt(group.dataset.min) === activeIndex;
                            gsap.to(group, {
                                autoAlpha: isActive ? 1 : 0,
                                y: isActive ? 0 : 15,
                                duration: 0.4,
                                overwrite: true
                            });
                        });

                        window.dispatchEvent(new CustomEvent('landmark-group-change', {
                            detail: { activeIndex }
                        }));
                    }
                }
            }
        });

        tl.fromTo(radiusCircle, 
            { width: 37, height: 37 }, 
            { width: endSize, height: endSize, ease: "none", duration: completionPoint }, 0
        );
        tl.to({}, { duration: 1 - completionPoint });

        return () => {
            // Cleanup to reset styles on resize or orientation change
            gsap.set(radiusCircle, { clearProps: "all" });
        };
    });
};





export { 
    simpleParalax, 
    cardOverlap, 
    pillShapeTransform, 
    initTextReveal, 
    initMapSlider
};
